/**
 * Big Ridge Farm - Frontend JavaScript
 */

// Import styles
import "./scss/frontend.scss";

// Import JS modules
// import "./js/navigation";
// import "./js/sliders";

// DOM Ready
document.addEventListener("DOMContentLoaded", () => {
  console.log("Big Ridge Farm theme loaded");
});
